import React, { useState } from 'react';
import { tWithKeyAttr as t } from '../../../i18nHelper';
import styles from '../forms.module.css';
import { IUserReport } from '../../../services/types/users.types';
import UpdateUserBalancePopup from '../../modals/updateUserBalancePopup/updateUserBalancePopup';
import Modal from '../../modals/modal/Modal';

interface UpdateUserBalanceComponentProps {
  user: IUserReport;
  onSuccess?: () => void;
}

function UpdateUserBalanceComponent({
  user,
  onSuccess,
}: UpdateUserBalanceComponentProps) {
  const [openUpdateBalanceModal, setOpenUpdateBalanceModal] = useState(false);

  return (
    <div className={styles.contactTabsEmptyState}>
      <div className={styles.contactTabsEmptyStateContent}>
        <div className={styles.contactTabsEmptyIcon}>👤</div>
        <p>
          {t('USER_BALANCE')}: <span dir="ltr">{user.Balance ?? 0}</span>
        </p>
      </div>
      <button
        type="button"
        className={styles.contactTabsEmptyStateButton}
        onClick={() => setOpenUpdateBalanceModal(true)}
      >
        {t('UPDATE_USER_BALANCE')}
      </button>
      {openUpdateBalanceModal && <UpdateUserBalancePopup user={user} onClose={() => setOpenUpdateBalanceModal(false)} onSuccess={onSuccess} />}
    </div>
  );
}

export default UpdateUserBalanceComponent;
